import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import DashboardFailureModal from './DashboardFailureModal';

export const WAITLIST_HEADING = "We're so sorry";
export const WAITLIST_MESSAGE =
  "IMABIRD is full right now, so you're on the waitlist. Please try signing in again a little later. Thank you so much for your patience.";

/* Answers a sign-in the backend refused because the account is waitlisted,
   whichever page the sign-in started from. */
const AccountWaitlistDialog: React.FC = () => {
  const { waitlisted, dismissWaitlist } = useAuth();
  if (!waitlisted) return null;

  return (
    <DashboardFailureModal
      heading={WAITLIST_HEADING}
      message={WAITLIST_MESSAGE}
      ariaLabel="Waitlist"
      onClose={dismissWaitlist}
    />
  );
};

export default AccountWaitlistDialog;
